import { useEffect } from 'react';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import './Calendar.css';

import useClinicCalendar from './hooks/useClinicCalendar';
import useSpecialtyClinics from './hooks/useSpecialtyClinics';
import RoundedContainer from './layouts/RoundedContainer';
import { ClinicsEnum } from './common/enums';
import CalendarComponent from './components/CalendarComponent';

const DIV_DEFAULT_18PX_PREVENT_LAYOUT_SHIFT = {
  height: '18px'
}

export default function CalendarPublic(props: RouteComponentProps) {
  useEffect(() => {
    document.title = "Clinic Schedule: Public Calendar"
  }, []);

  const { search } = useLocation();
  const selectedClinic = new URLSearchParams(search).get("clinic") as unknown as ClinicsEnum

  function setSelectedClinic(selectedClinic: ClinicsEnum | undefined) {
    if (selectedClinic) {
      props.history.push({
        pathname: props.location.pathname,
        search: "?" + new URLSearchParams({clinic: selectedClinic}).toString()
      })
    } else {
      props.history.push({
        pathname: props.location.pathname
      })
    }
  }

  const {
    isDoingFirstLoad: isDoingFirstSpecialtyClinicLoad,
    specialtyClinicData
  } = useSpecialtyClinics(false);

  const {
    availabilityInfoForEachDay,
    onyen,
    isDoingFirstLoad,
    isLoading,
    userInfo,
    anyWarningAboutDataFeedsUsed
  } = useClinicCalendar(false, specialtyClinicData, selectedClinic); 

  function noOnyenFound(){
    return (
      <RoundedContainer title={<span className="fs-4">Please be sure the account has public calendar enabled and try again</span>} subheading={`We're sorry, we are unable to access the calendar for user "${onyen}"`}>
        <div className="tw-relative md:tw-hidden">
        <div className="tw-animate-pulse tw-w-6 tw-h-6 tw-absolute tw-right-0 tw--top-10">
            <svg className="tw-w-6 tw-h-6 tw-text-blue-500 tw--rotate-90" fill="none" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
       </RoundedContainer>
    );
  }

  function onyenFound(){
    return (
      <RoundedContainer title={<span className="fs-4">Available Schedule for {userInfo?.data?.displayName ? userInfo.data.displayName : '...'}</span>} subheading="">
        <div className="mb-3">
          <div style={DIV_DEFAULT_18PX_PREVENT_LAYOUT_SHIFT}>{isLoading && !isDoingFirstLoad ? "Refreshing available time slots..." : ""}</div>
        </div>

        <CalendarComponent 
          availabilityInfoForEachDay={availabilityInfoForEachDay}
          isDoingFirstLoad={isDoingFirstLoad}
          isDoingFirstSpecialtyClinicLoad={isDoingFirstSpecialtyClinicLoad}
          selectedClinic={selectedClinic}
          setSelectedClinic={setSelectedClinic}
          anyWarningAboutDataFeedsUsed = {anyWarningAboutDataFeedsUsed}
        />
      </RoundedContainer>
    );
  }

  return (
    (userInfo?.data?.displayName || isLoading) ? onyenFound() : noOnyenFound()
  )
}
